import * as Sentry from "@sentry/browser";

const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
const ENVIRONMENT = import.meta.env.PROD ? 'production' : 'development';

export function initSentry() {
  if (!SENTRY_DSN) {
    console.warn('Sentry DSN not found. Error tracking is disabled.');
    return;
  }

  Sentry.init({
    dsn: SENTRY_DSN,
    environment: ENVIRONMENT,
    integrations: [],
    tracesSampleRate: ENVIRONMENT === 'production' ? 0.2 : 1.0,
    beforeSend(event) {
      // Don't send events in development
      if (ENVIRONMENT !== 'production') {
        return null;
      }
      return event;
    },
  });
}

export function captureError(error: Error, context?: Record<string, any>) {
  if (ENVIRONMENT === 'production') {
    Sentry.captureException(error, {
      extra: context,
    });
  } else {
    console.error('Error:', error, 'Context:', context);
  }
}
